/**
 * @file GDotObjField.jsx
 * @description input field for mutiple gDots for associated genomeBuilds
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jun 27, 2024 13:30
 */
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';

import { objectExists } from 'src/@common/utilities';
import VeriomeTextField from 'src/components/fieldComponents/VeriomeTextField';

function GDotObjField(props) {
    const {
        containerSxStyle,
        fieldErrors,
        formFields,
        handleBlur,
        handleChange,
    } = props;

    const fieldWidth = 220;

    return (

        <Card variant="outlined" sx={containerSxStyle}  >

            <CardContent>
                <FormLabel sx={{ mt: '3px', mb: '5px' }} component="legend">G-Dot</FormLabel>

                {objectExists(formFields) &&

                    <>
                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-19 G-Dot'}
                            fieldName={'hg19.gDot'}
                            currentValue={formFields.hg19.gDot ? formFields.hg19.gDot : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={false}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg19.gDot');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg19.gDot');
                            }}
                        />

                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-19 RefSeq'}
                            fieldName={'hg19.refSeq'}
                            currentValue={formFields.hg19.refSeq ? formFields.hg19.refSeq : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={false}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg19.refSeq');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg19.refSeq');
                            }}
                        />

                        <Divider sx={{ marginTop: '8px', borderBottomWidth: '4px', background: 'lightGray' }} />

                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-38'}
                            fieldName={'hg38.gDot'}
                            currentValue={formFields.hg38.gDot ? formFields.hg38.gDot : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={true}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg38.gDot');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg38.gDot');
                            }}
                        />

                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-38 RefSeq'}
                            fieldName={'hg38.refSeq'}
                            currentValue={formFields.hg38.refSeq ? formFields.hg38.refSeq : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={true}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg38.refSeq');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg38.refSeq');
                            }}
                        />

                    </>
                }

            </CardContent>

        </Card>
    );
}

GDotObjField.propTypes = {
    gDotOptions: PropTypes.array,
    containerSxStyle: PropTypes.object,
    fieldErrors: PropTypes.object.isRequired,
    formFields: PropTypes.object.isRequired,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func.isRequired,
};

export default GDotObjField;
